import React from 'react';
import { IconButton, TrevorIcon } from '@trevor/ui-components';
import { useAppSelector } from '@/store/hooks';
import { getPlatformName } from '@/util/getPlatformName';
import { selectIsRedoStackEmpty } from '../slice';
import { useRedo } from '../hooks/useRedo';

export const RedoButton = () => {
  const isRedoStackEmpty = useAppSelector(selectIsRedoStackEmpty);
  const redo = useRedo();

  const tooltip = `Redo (${
    getPlatformName() === 'Macintosh' ? 'CMD' : 'Ctrl'
  } + y)`;

  return (
    <IconButton
      onClick={redo}
      icon={<TrevorIcon name="redo" $color="#666" />}
      tooltip={tooltip}
      disabled={isRedoStackEmpty}
    />
  );
};
